// Config untuk status backend dan mode offline
export const appConfig = {
  backendEnabled: true, // Set ke false untuk mode offline/placeholder
  showBackendNotice: true, // Tampilkan banner informasi backend
  offlineMode: false, // Mode offline
  debugMode: false, // Debug logs
  isDevelopment: process.env.NODE_ENV === 'development' || false, // Development mode detection
};


// Centralized logging utility
export const logger = {
  debug: (...args: any[]) => {
    if (appConfig.debugMode || appConfig.isDevelopment) {
      console.log(...args);
    }
  },
  info: (...args: any[]) => {
    if (appConfig.debugMode || appConfig.isDevelopment) {
      console.info(...args);
    }
  },
  warn: (...args: any[]) => {
    console.warn(...args);
  },
  error: (...args: any[]) => {
    console.error(...args);
  },
};